import TriangleShape from 'assets/images/claim-polygon.svg'
import Logo from 'assets/images/waynimovil.svg'
import HandsUp from 'assets/images/emojis/hands-up-yellow.png'
import Sunglasses from 'assets/images/emojis/sunglasses-guy.png'
import Shape1 from 'assets/images/index-shape-1.svg'
import Shape2 from 'assets/images/index-shape-2.svg'

import RoundedIcon from 'components/RoundedIcon'

export default function MainPanel() {
  return (
    <div className='md:h-screen w-full relative md:w-1/2 box-border bg-purple-900'>
      <img
        src={Shape1}
        alt=''
        className='absolute md:rotate-0 rotate-[75deg] top-12 md:top-6 -left-14 md:left-1'
      />
      <img
        src={Shape2}
        alt=''
        className='absolute top-14 md:top-auto md:bottom-3 -right-36 md:right-1'
      />
      <div className='px-9 pt-6 z-10 pb-16 flex justify-center items-center md:h-screen flex-col'>
        <img
          alt='Waynimóvil'
          className='w-[16.25rem] md:w-full mb-8 block md:hidden mt-4'
          src={Logo}
        />
        <div className='text-black max-w-min mx-auto flex flex-col space-y-3'>
          <div className='flex gap-4 w-full items-center'>
            <RoundedTextBubble text='Una billetera' withShape />
            <RoundedIcon
              className='!h-10 !w-10 md:!w-15 md:!h-15'
              icon={<img className='w-4 md:w-7' src={Sunglasses} alt='' />}
            />
          </div>
          <div className='flex gap-4 w-full items-center'>
            <RoundedIcon
              className='!h-10 !w-10 md:!w-15 md:!h-15'
              icon={<img className='w-4 md:w-7' src={HandsUp} alt='' />}
            />
            <RoundedTextBubble text='hecha para vos' />
          </div>
        </div>
      </div>
    </div>
  )
}

const RoundedTextBubble = ({ className = '', text, withShape = false }) => (
  <div
    className={`relative h-10 md:h-15 min-w-max px-8 md:text-3xl rounded-full bg-green-800 text-center flex items-center justify-center ${className}`}
    style={{ fontFamily: 'FF-Prill' }}
  >
    {withShape && (
      <img
        className='absolute md:hidden left-4 -top-3'
        src={TriangleShape}
        alt=''
      />
    )}
    {text}
  </div>
)
